import React from "react";

export default function Cycle({ dateOption }) {
  const [displayValue, setDisplayValue] = React.useState("28");

  const handleChange = (event) => {
    const newDisplayValue = event.target.value;
    const filteredDisplayValue = newDisplayValue.replace(/[^0-9]/g, "");
    setDisplayValue(filteredDisplayValue);
  };

  if (dateOption == 'lastPeriod') {
    return (
      <div className="p-4 my-2 sm:my-4 bg-stone-100 rounded-lg">
        <div
          className="text-sm sm:text-base mb-2 cursor-default"
        >
          Durée du cycle
        </div>
        <div className="flex items-center gap-2">
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            className="py-2 w-16 sm:w-24 text-center px-2 font-bold rounded-lg text-base sm:text-lg focus:outline-none focus:ring focus:ring-slate-300 focus:border-slate-500"
            value={displayValue}
            role="spinbutton"
            onChange={handleChange}
          />
          <div className="text-base sm:text-xl font-bold cursor-default">
            jours
          </div>
        </div>
      </div>
    );
  }

}
